export default __webpack_public_path__ + "static/media/img-slider-om-wallet-6.5ccd4266.png";